/* eslint-disable no-console */
// import moment from "moment";
// import { native } from "../utils/hybrid";
// import { mapGetters, mapActions } from "vuex";

export default {
  install(Vue) {
    Vue.mixin({
      filters: {
        phone(val) {
          return val ? val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") : "";
        },

        // 限制字符串长度
        cutString(str, len) {
          // length属性读出来的汉字长度为1
          if (str.length * 2 <= len) {
            return str;
          }
          let strlen = 0;
          let s = "";
          for (let i = 0; i < str.length; i++) {
            s = s + str.charAt(i);
            if (str.charCodeAt(i) > 128) {
              strlen = strlen + 2;
              if (strlen >= len) {
                return s.substring(0, s.length - 1) + "...";
              }
            } else {
              strlen = strlen + 1;
              if (strlen >= len) {
                return s.substring(0, s.length - 2) + "...";
              }
            }
          }
          return s;
        }
      },
      computed: {},
      methods: {}
    });
    // window.fn_shareInvitationFriend = () => {};
  }
};
